import type { NuxtApp } from 'nuxt/schema';

export default defineNuxtPlugin({
  async setup() {
    const { $auth, $store, $api } = useNuxtApp();
    const parentalControl = reactive({
      maxAgeGroup: '',
      isActive: false,
      async getUserParentalConfig(): Promise<unknown> {
        try {
          let user = $auth.user as { roles: string[] };

          if (user?.roles && user?.roles[0] && user?.roles[0] === 'user') {
            const { password, maxAgeGroup, isActive } =
              await $api.endPoints.getParntalControlAcount();
            this.maxAgeGroup = maxAgeGroup;
            this.isActive = isActive;
            const maxRating = this.isActive
              ? maxAgeGroup
              : +$api.tenant?.default?.maxRating || 60;
            $store.commit('setParentalConfig', { maxRating, isActive });
            return { password, maxAgeGroup, isActive };
          } else {
            $store.commit('setParentalConfig', {
              maxRating: +$api.tenant?.default?.maxRating || 60,
              isActive: false,
            });
          }
        } catch (error) {
          // TODO hanlde or skip error
          // console.info(error);
        }
      },
    });
    if (process.client) {
      parentalControl.getUserParentalConfig();
    }

    return {
      provide: {
        parentalControl: parentalControl,
      },
    };
  },
});
